import Vue from 'vue';

Vue.directive('press', {
	inserted(el, binding, vnode) {
		el.addEventListener('keyup', ({ key }) => {
			if (!key) return;
			if (Object.keys(binding.modifiers).some(e => e.toLowerCase() === key.toLowerCase())) {
				binding.value.call(vnode.context);
			}
		});
	}
})